export default "//cloud.imgsmail.ru/cloud.mail.ru/187531/img/build/errors/error-bad-browser.png";